export default function switchToQRBService(
  $http,
  $window,
  NotificationService,
  RESOURCES
){
  function switchToQRB(merchant){
    if (!merchant.id) {
      NotificationService.error('Invalid merchant ID');
      return;
    }

    return $http.post(RESOURCES.REDIRECT_TO_QRB + '/'+ merchant.id, {}).then( function(res) {
      const {redirectUrl, accessToken, refreshToken} = res.data;
      $window.open(`${redirectUrl}?accessToken=${accessToken}&refreshToken=${refreshToken}`, '_blank');
      });
  }

  return { switchToQRB: switchToQRB };
}



// WEBPACK FOOTER //
// ./src/app/common/services/switchToQRB.service.js